import { render, staticRenderFns } from "./PrintReceive.vue?vue&type=template&id=2bb4d4b8&"
import script from "./PrintReceive.vue?vue&type=script&lang=js&"
export * from "./PrintReceive.vue?vue&type=script&lang=js&"
import style0 from "./PrintReceive.vue?vue&type=style&index=0&id=2bb4d4b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports